import './team-area.css';
import PersonCard from '../PersonCard/PersonCard';
import gründerImg from '../../assets/img/about/asset 7.jpeg'
import managerImg from '../../assets/img/about/asset 8.jpeg'
import sozialPersonImg from '../../assets/img/about/asset 9.jpeg'
import verwalterImg1 from '../../assets/img/about/asset 10.jpeg'
import verwalterImg2 from '../../assets/img/about/asset 11.jpeg'
import verwalterImg3 from '../../assets/img/about/asset 12.jpeg'
import verwalterImg4 from '../../assets/img/about/asset 13.jpeg'

const TeamArea = () => {
	return (
		<section className="team-area">
			<div className="center-title">
				<span>Qualifiziert und examiniert</span>
				<h1>Das sind wir</h1>
			</div>
			<div className="content">
				<div className="container">
					<div className="teams-box">
						<PersonCard field="Gründung" img={ gründerImg} name="Elisabeth Petker" jobTitle="Gründerin" type="big" />
						<PersonCard field="Management" img={ managerImg} name="Katharina Diring" jobTitle="Geschäftsführung" type="big" />
					</div>
				</div>
				<div className="container">
					<div className="teams-box">
						<PersonCard field={"Sozialer Dienst"} img={ sozialPersonImg } name="Madeline Temme" />
					</div>
				</div>
				<div className="container">
					<h3 className='group-field'>Verwaltung</h3>
					<div className="teams-box">
						<PersonCard img={ verwalterImg1 } name="Katharina Bednara" />
						<PersonCard img={ verwalterImg2 } name="Claudia Wieland" />
						<PersonCard img={ verwalterImg3 } />
						<PersonCard img={ verwalterImg4 } />
					</div>
				</div>
			</div>
			

		</section>
	)
}

export default TeamArea
